<script>
/**
 * ****************************************************************************
 * @description     :   MainMenu
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import libraries
 */
import { mapState } from 'vuex';
import _ from 'lodash';
import menus, { NeedMoreCheck } from './menu';
import helpers from '@/utils/helpers';

/**
 * import template
 */
import template from './template.html';

/**
 * Define main layout
 */
const MainMenu = {
    name: 'Menu',
    template: template,
    data() {
        return {
            menus: menus,
            permission: helpers.permission(),
            isSwitchUser: helpers.isSwitchUser()
        };
    },
    computed: {
        ...mapState('app', [
            'user',
            'menuPermission',
            'notification',
            'screenId',
            'isPublic',
            'isMobile'
        ])
    },
    watch: {
        menuPermission() {
            setTimeout(() => {
                this.checkPermission();
                this.setActiveItem();
            }, 100);
        },
        user() {
            setTimeout(() => {
                this.permission = helpers.permission();
                this.isSwitchUser = helpers.isSwitchUser();
                this.checkPermission();
            }, 100);
        },
        'user.switchUser'() {
            setTimeout(() => {
                this.permission = helpers.permission();
                this.isSwitchUser = helpers.isSwitchUser();
                this.checkPermission();
            }, 100);
        },
        screenId() {
            setTimeout(() => {
                this.setActiveItem();
            }, 100);
        },
        isMobile() {
            setTimeout(() => {
                this.setActiveItem();
            }, 100);
        }
    },
    mounted() {
        this.checkPermission();
    },
    methods: {
        setActiveItem() {
            const length = this.menus.length;
            const pathname =
                window.location.pathname === '/'
                    ? ''
                    : window.location.pathname;
            for (let i = 0; i < length; i++) {
                const countChild = this.menus[i].childMenus?.length ?? 0;
                if (countChild > 0) {
                    for (let j = 0; j < countChild; j++) {
                        if (
                            this.menus[i].childMenus[j].url.indexOf(pathname) >=
                            0
                        ) {
                            if (pathname == '/cm/cm0100i') {
                                if (
                                    (helpers.decodeParams(this.$route.query.p)
                                        ?.from ?? 0) ==
                                    this.menus[i].childMenus[j].from
                                ) {
                                    this.menus[i].childMenus[j].isActive = true;
                                } else {
                                    this.menus[i].childMenus[
                                        j
                                    ].isActive = false;
                                }
                            } else {
                                this.menus[i].childMenus[j].isActive = true;
                            }
                        } else {
                            this.menus[i].childMenus[j].isActive = false;
                        }
                    }
                } else {
                    if (this.menus[i].url.indexOf(pathname) >= 0) {
                        this.menus[i].isActive = true;
                    } else {
                        this.menus[i].isActive = false;
                    }
                }
            }
        },
        setIsActive(item) {
            const length = this.menus.length;
            for (let i = 0; i < length; i++) {
                const countChild = this.menus[i].childMenus.length;
                if (countChild > 0) {
                    for (let j = 0; j < countChild; j++) {
                        this.menus[i].childMenus[j].isActive = false;
                    }
                } else {
                    this.menus[i].isActive = false;
                }
            }
            item.isActive = true;
        },
        checkPermission() {
            const length = this.menus.length;
            for (let i = 0; i < length; i++) {
                const countChild = this.menus[i].childMenus.length;
                if (countChild > 0) {
                    for (let j = 0; j < countChild; j++) {
                        if (
                            this.menus[i].childMenus[j].role.includes(
                                this.permission
                            )
                        ) {
                            this.menus[i].childMenus[j].hadPermission = true;
                            if (
                                NeedMoreCheck[this.permission]?.includes(
                                    this.menus[i].childMenus[j].id
                                )
                            ) {
                                const per = _.findLast(this.menuPermission, {
                                    機能ID: this.menus[i].childMenus[j].id
                                });
                                if (
                                    !(
                                        per &&
                                        ((this.menus[i].childMenus[j]
                                            .isCheck利用者権限 &&
                                            per.利用者権限 == 1) ||
                                            (!this.menus[i].childMenus[j]
                                                .isCheck利用者権限 &&
                                                per.上司権限 == 1))
                                    )
                                ) {
                                    this.menus[i].childMenus[
                                        j
                                    ].hadPermission = false;
                                }
                            }
                        } else {
                            this.menus[i].childMenus[j].hadPermission = false;
                        }
                    }
                } else {
                    if (this.menus[i].role.includes(this.permission)) {
                        this.menus[i].hadPermission = true;
                        if (
                            NeedMoreCheck[this.permission]?.includes(
                                this.menus[i].id
                            )
                        ) {
                            const per = _.findLast(this.menuPermission, {
                                機能ID: this.menus[i].id
                            });
                            if (
                                !(
                                    per &&
                                    ((this.menus[i].isCheck利用者権限 &&
                                        per.利用者権限 == 1) ||
                                        (!this.menus[i].isCheck利用者権限 &&
                                            per.上司権限 == 1))
                                )
                            ) {
                                this.menus[i].hadPermission = false;
                            }
                        }
                    } else {
                        this.menus[i].hadPermission = false;
                    }
                }
            }
            for (let i = 0; i < length; i++) {
                const countChild = this.menus[i].childMenus.length;
                if (countChild > 0) {
                    const enable = _.find(this.menus[i].childMenus, {
                        hadPermission: true
                    });
                    if (!enable) {
                        this.menus[i].hadPermission = false;
                    } else {
                        this.menus[i].hadPermission = true;
                    }
                }
            }
        },
        haveNotification(item) {
            return (
                (item.id == 'Gs0710i' &&
                    this.notification.本人アラート件数 &&
                    this.notification.本人アラート件数 > '0') ||
                (item.id == 'Gs0711v' &&
                    this.notification.アラート件数 &&
                    this.notification.アラート件数 > '0') ||
                (item.id == 'Gs0050v' &&
                    this.notification.承認待ち件数 &&
                    this.notification.承認待ち件数 > '0')
            );
        },
        getNotification(item) {
            // eslint-disable-next-line prettier/prettier
            return item.id == 'Gs0710i' ? this.notification.本人アラート件数 : item.id == 'Gs0050v' ? this.notification.承認待ち件数 : this.notification.アラート件数;
        }
    }
};
export default MainMenu;
</script>
